export default {
    Trans: {
        beginning: "Début",
        cost: "Coût",
        day: "jour",
        week: "semaine",
        month: "mois",
        days: "jours",
        description: "Description",
        delete: "Supprimer",
        download: "Télécharger",
        end: "Fin",
        edit: "Modifier",
        save: "Enregistrer",
        send: "Envoyer",
        cancel: "Annuler",
        total: "Total",
        close: "Fermer",
        accept: "Accepter",
        ok: "Ok",
        details: "Détails",
        knots: 'nœuds',
        back: 'Précedent',
        confirm: 'Confirmer',
        field_mandatories: "Les champs marqués* sont obligatoires",
        selectOption: "Choississez",
        loading: "Chargement",
        mister: "Monsieur",
        miss: "Madame",
        phone_mini: 'Tél.',
        fax: 'Fax',
        facebook: "Facebook",
        linkedin: "Linkedin",
        twitter: "Twitter",
        today: "Ajourd'hui",
        otherDay: 'Un autre jour',
        matin: "Matin",
        apresmidi: "Après-midi",
        refused: "Refusée",
        approved: "Acceptée",
        requested: "En attente",
        accepted: "Acceptée",
        miscellanous: "Divers",
        date: {
            _: "Date",
            monday: "Lundi",
            tuesday: "Mardi",
            wednesday: "Mercredi",
            thursday: "Jeudi",
            friday: "Vendredi",
            saturday: "Samedi",
            sunday: "Dimanche",
            january: "Janvier",
            february: "Février",
            march: "Mars",
            april: "Avril",
            may: "Mai",
            june: "Juin",
            july: "Juillet",
            august: "Août",
            september: "Septembre",
            october: "Octobre",
            november: "Novembre",
            december: "Décembre",
        },
        dateMin: {
            monday: "Lun",
            tuesday: "Mar",
            wednesday: "Mer",
            thursday: "Jeu",
            friday: "Ven",
            saturday: "Sam",
            sunday: "Dim",
        },
        average_minified: 'Moy.',
        max: 'Max',
        significant_height: 'Haut. sign.',
        period: 'Période',
        welcome: "Bonjour __USER__",
        address: {
            _: "Adresse",
            street: "Rue",
            country: "Pays",
            city: "Ville",
            postalCode: "Code Postal",
        },
        field: {
            error: {
                required: 'Le champs __field__ est requis.',
                length_min: 'Le champs __field__  doit faire au moins __length__ caractères.',
                password_not_equal: 'Les mots de passe ne correspondent pas.',
                message: 'Une erreur est survenue.',
            }
        },
    },
    AntDesign: {
        locale: "fr_FR",
        DatePicker: {
            okText: "OK",
            dismissText: "Annuler",
            extra: "extra",
            DatePickerLocale: {
                year: "Année",
                month: "Mois",
                day: "Jour",
                hour: "Heure",
                minute: "Minute",
                am: "Matin",
                pm: "Après-midi"
            }
        },
        DatePickerView: {
            year: "Année",
            month: "Mois",
            day: "Jour",
            hour: "Heure",
            minute: "Minute",
            am: "Matin",
            pm: "Après-midi"
        },
        InputItem: {
            confirmLabel: "Entrée",
            backspaceLabel: "Suppr",
            cancelKeyboardLabel: "Annuler"
        },
        Modal: {
            okText: "OK",
            cancelText: "Annuler",
            buttonText: "Texte"
        },
        Pagination: {
            prevText: "Précédent",
            nextText: "Suivant"
        },
        Picker: {
            okText: "OK",
            dismissText: "Fermer",
            extra: "Extra"
        },
        SearchBar: {
            cancelText: "Annuler"
        },
        ListView: {
            Done: "Terminé",
            Loading: "Chargement",
            refreshableTitlePull: "Rafraichir",
            refreshableTitleRelease: "Rafraichir",
            refreshableTitleRefreshing: "Rafraichir",
            noData: "Aucune donnée"
        }
    },
    Table: {
        filterTitle: "Rechercher...",
        filterConfirm: "OK",
        filterReset: "Réinitialiser",
        emptyText: "Aucune donnée"
    },
    Modal: {
        okText: "OK",
        cancelText: "Annuler",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Annuler"
    },
    Transfer: {
        notFoundContent: "Pas de résultat",
        searchPlaceholder: "Recherche",
        itemUnit: "élément",
        itemsUnit: "éléments"
    },
    Select: {
        notFoundContent: "Pas de résultat"
    },
    Pagination: {
        items_per_page: "/ page",
        jump_to: "Allez à",
        page: "",
        prev_page: "Page Précédente",
        next_page: "Page Suivante",
        prev_5: "5 Pages Précédentes",
        next_5: "5 Pages Suivantes",
        prev_3: "3 Pages Précédentes",
        next_3: "3 Pages Suivantes"
    },
    TimePicker: {
        placeholder: ""
    },
    DatePicker: {
        lang: {
            today: "Aujourd'hui",
            now: "Maintenant",
            backToToday: "Retour à aujourdh'hui",
            ok: "Ok",
            clear: "Vider",
            month: "Mois",
            year: "Année",
            timeSelect: "Sélectionner l'heure",
            dateSelect: "Sélectionner une date",
            monthSelect: "Sélectionner un mois",
            yearSelect: "Sélectionner une année",
            decadeSelect: "Sélectionner une décénie",
            yearFormat: "YYYY",
            dateFormat: "M/D/YYYY",
            dayFormat: "D",
            dateTimeFormat: "M/D/YYYY HH:mm:ss",
            monthFormat: "MMMM",
            monthBeforeYear: true,
            previousMonth: "Mois précédent (PageUp)",
            nextMonth: "Mois suivant (PageDown)",
            previousYear: "Année précédente (Control + left)",
            nextYear: "Année suivante (Control + right)",
            previousDecade: "Décennie précédente",
            nextDecade: "Décennie suivante",
            previousCentury: "Siècle précédent",
            nextCentury: "Siècle suivant",
            placeholder: "Sélectionnez une date",
            rangePlaceholder: ["Date de début", "Date de fin"]
        }
    },
    ImagePicker: {
        image: {
            title: "Sélectionnez une Photo",
            cancelButtonTitle: "Annuler",
            takePhotoButtonTitle: "Prendre une Photo",
            chooseFromLibraryButtonTitle: "Parcourir mes Photos",
        },
        video: {
            title: "Prendre une vidéo",
            takePhotoButtonTitle: "Prendre une vidéo",
        }
    }
};
//# sourceMappingURL=ias.fr.js.map